module.exports = __webpack_public_path__ + "static/media/ute_logo.31407653.svg";